export enum MobileInspectionStatus {
  TRIGGERED = 'TRIGGERED',
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
}
